import axios from 'axios';

const HOSTAPI = process.env.REACT_APP_BASE_URL;

const UpdateCurrentSlide = async (payload: any, eventId: any) => {
  try {
    const response = await axios.put(`${HOSTAPI}/events/${eventId}/store-current-slide`, payload, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response
  } catch (error: any) {
    return {
      status: error.response.status,
      data: error.response.data,
    };
  }
};

export default UpdateCurrentSlide;
